// extracted by mini-css-extract-plugin
export var description = "FeatureCompare-module--description--68409";
export var dimmed = "FeatureCompare-module--dimmed--b6264";
export var gridBlock = "FeatureCompare-module--gridBlock--5d3af";
export var gridBlockContainer = "FeatureCompare-module--gridBlockContainer--e6026";
export var gridCol = "FeatureCompare-module--gridCol--c349b";
export var gridList = "FeatureCompare-module--gridList--0d34a";
export var title = "FeatureCompare-module--title--b17d2";
export var wrapper = "FeatureCompare-module--wrapper--f7f17";